import {gql} from '@apollo/client';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import APIUtil from 'util/APIUtil';

import {isRegistryEmbeddingEnabled} from '../IsEmbeddingEnabled';
import {
  GetBioentityAnalyticsDashboardQuery,
  GetBioentityAnalyticsDashboardQueryVariables,
} from './__generated/GetBioentityAnalyticsDashboardQuery';

export const GET_BIOENTITY_ANALYTICS_DASHBOARD_QUERY = gql`
  query GetBioentityAnalyticsDashboardQuery($bioentityId: StrictString!)
  @skipAudit
  @engComponent(name: INSIGHTS) {
    bioentity(id: $bioentityId) {
      ... on RegistryItemInterface {
        id
        tagSchema {
          ... on TagSchemaNode {
            ...AnalyticsDashboardLinkParentGraphQL
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('AnalyticsDashboardLinkParent').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export async function fetchBioentityAnalyticsDashboard(
  bioentityId: string
): Promise<GetBioentityAnalyticsDashboardQuery> {
  return await doQuerySafe<GetBioentityAnalyticsDashboardQuery, GetBioentityAnalyticsDashboardQueryVariables>(
    {query: GET_BIOENTITY_ANALYTICS_DASHBOARD_QUERY},
    {
      variables: {
        bioentityId,
      },
    }
  );
}

export async function fetchBioentityAnalyticsDashboardIfEnabled(
  fileId: string
): Promise<GetBioentityAnalyticsDashboardQuery | null> {
  if (isRegistryEmbeddingEnabled() && APIUtil.isBiologicalEntity(fileId)) {
    return await fetchBioentityAnalyticsDashboard(fileId);
  } else {
    return null;
  }
}
